const isProduction = window.env.CONFIG_ENVIRONMENT === "production";

export const ApiConfig = {
  API_URL: window.env.CONFIG_API_GATEWAY_URL,
  BUILD_NUMBER: isProduction ? "0.0.24" : window.env.CONFIG_BUILD_NUMBER,
  BUILD_TIME: isProduction ? "" : window.env.CONFIG_BUILD_TIME,
  PROJECT_ID: {
    USER_SERVICE: window.env.CONFIG_NODEJS_SCYBER_MANAGER_SERVICE_ID,
    ADMIN_SERVICE: window.env.CONFIG_NODEJS_SCYBER_ADMIN_SERVICE_ID,
  },
};

export const API_OAUTH_ROUTER = {
  VERSION: "v1",
  get API_LOGIN() {
    return `${this.VERSION}/auth/login`;
  },
  get VERIFY_OTP_LOGIN() {
    return `${this.VERSION}/auth/verify-otp-login`;
  },
  get VERIFY_OTP_FORGOT_PASSWORD() {
    return `${this.VERSION}/auth/verify-otp-forgot-password`;
  },
  get RESET_PASSWORD() {
    return `${this.VERSION}/auth/reset-password`;
  },
  get CHANGE_PASSWORD() {
    return `${this.VERSION}/auth/change-password`;
  },
};

export const API_AREAS_ROUTER = {
  VERSION: "v1",
  get CREATE_AREAS() {
    return `${this.VERSION}/areas/create`;
  },

  UPDATE_AREAS(id: string) {
    return `${this.VERSION}/areas/${id}/update`;
  },

  get API_CHANGE_STATUS() {
    return `${this.VERSION}/areas/change-status`;
  },

  get API_GET_AREAS() {
    return `${this.VERSION}/areas`;
  },

  get COUNT_TAB_AREAS() {
    return `${this.VERSION}/areas/count`;
  },
  CONFIG_PRICE_AREAS() {
    return `${this.VERSION}/areas/config-price`;
  },

  CONTROL_COMPUTER_AREAS() {
    return `${this.VERSION}/areas/control-computers`;
  },
};

export const API_BRANCH_ROUTER = {
  VERSION: "v1",
  get API_GET_BRANCHES() {
    return `${this.VERSION}/branches`;
  },
  get API_GET_BRANCHES_COUNT_TAB() {
    return `${this.VERSION}/branches/count`;
  },
  API_CREATE_BRANCH() {
    return `${this.VERSION}/branches/create`;
  },
  API_UPDATE_BRANCH(id: string) {
    return `${this.VERSION}/branches/${id}/update`;
  },
  API_GET_BRANCH_DETAIL(id: string) {
    return `${this.VERSION}/branches/${id}/detail`;
  },
  API_CHANGE_STATUS_BRANCH() {
    return `${this.VERSION}/branches/change-status`;
  },
  get API_GET_BRANCHES_WORKING() {
    return `${this.VERSION}/branches/working`;
  },
};

export const API_EMPLOYEE_ROUTER = {
  VERSION: "v1",

  get API_GET_EMPLOYEES() {
    return `${this.VERSION}/employees`;
  },
  get API_GET_EMPLOYEES_COUNT_TAB() {
    return `${this.VERSION}/employees/count-tab`;
  },
  get API_CREATE_EMPLOYEE() {
    return `${this.VERSION}/employees/create`;
  },
  API_UPDATE_EMPLOYEE(id: string) {
    return `${this.VERSION}/employees/${id}/update`;
  },
  API_GET_EMPLOYEE_DETAIL(id: string) {
    return `${this.VERSION}/employees/${id}/detail`;
  },
  API_CHANGE_STATUS_EMPLOYEE(id: string) {
    return `${this.VERSION}/employees/${id}/change-status`;
  },
  API_RESET_PASSWORD_EMPLOYEE(id: string) {
    return `${this.VERSION}/employees/${id}/reset-password`;
  },
  get API_UPDATE_PROFILE() {
    return `${this.VERSION}/employees/update-profile`;
  },
};

export const API_RECHARGE_PACKAGE_ROUTER = {
  VERSION: "v1",
  get API_GET_RECHARGE_PACKAGES() {
    return `${this.VERSION}/recharge-packages`;
  },
  get API_GET_RECHARGE_PACKAGES_COUNT_TAB() {
    return `${this.VERSION}/recharge-packages/count`;
  },
  API_CREATE_RECHARGE_PACKAGE() {
    return `${this.VERSION}/recharge-packages/create`;
  },
  API_UPDATE_RECHARGE_PACKAGE(id: string) {
    return `${this.VERSION}/recharge-packages/${id}/update`;
  },
  API_CHANGE_STATUS_RECHARGE_PACKAGE() {
    return `${this.VERSION}/recharge-packages/change-status`;
  },
};

export const API_DEPARTMENTS_ROUTER = {
  VERSION: "v1",
  get API_GET_DEPARTMENTS() {
    return `${this.VERSION}/departments`;
  },
  get API_GET_PRIVILEGES() {
    return `${this.VERSION}/privileges`;
  },
  get API_GET_DEPARTMENTS_COUNT_TAB() {
    return `${this.VERSION}/departments/count-tab`;
  },
  API_CHANGE_STATUS_DEPARTMENT(id: string) {
    return `${this.VERSION}/departments/${id}/status`;
  },
  API_CREATE_DEPARTMENT() {
    return `${this.VERSION}/departments/create`;
  },
  API_UPDATE_DEPARTMENT(id: string) {
    return `${this.VERSION}/departments/${id}/update`;
  },
  API_GET_DEPARTMENT_DETAIL(id: string) {
    return `${this.VERSION}/departments/${id}/detail`;
  },
};

export const ADMINISTRATIVE_UNITS_ROUTER = {
  VERSION: "v1",
  get API_GET_ADMINISTRATIVE_UNITS_CITIES() {
    return `${this.VERSION}/administrative-units/cities`;
  },
  get API_GET_ADMINISTRATIVE_UNITS_DISTRICTS() {
    return `${this.VERSION}/administrative-units/districts`;
  },
  get API_GET_ADMINISTRATIVE_UNITS_WARDS() {
    return `${this.VERSION}/administrative-units/wards`;
  },
};

export const API_UPLOAD_ROUTER = {
  VERSION: "v1",
  get API_UPLOAD() {
    return `${this.VERSION}/upload/files`;
  },
  get API_SHORT() {
    return `${this.VERSION}/upload/short`;
  },
};

export const API_COMPUTERS_ROUTER = {
  VERSION: "v1",
  get API_GET_COMPUTERS() {
    return `${this.VERSION}/computers`;
  },
  get API_GET_COMPUTERS_COUNT_TAB() {
    return `${this.VERSION}/computers/count`;
  },
  API_CREATE_COMPUTER() {
    return `${this.VERSION}/computers/create`;
  },
  API_UPDATE_COMPUTER(id: string) {
    return `${this.VERSION}/computers/${id}/update`;
  },

  API_CHANGE_STATUS_COMPUTER() {
    return `${this.VERSION}/computers/change-status`;
  },
  API_GET_COMPUTER_DETAIL(id: string) {
    return `${this.VERSION}/computers/${id}/detail`;
  },

  API_UPDATE_NOTE(id: string) {
    return `${this.VERSION}/computers/${id}/update-note`;
  },
};

export const API_GAMES_ROUTER = {
  VERSION: "v1",
  get API_GET_GAMES() {
    return `${this.VERSION}/games`;
  },
  get API_GET_GAMES_COUNT_TAB() {
    return `${this.VERSION}/games/count`;
  },
  API_CREATE_GAME() {
    return `${this.VERSION}/games/create`;
  },
  API_UPDATE_GAME(id: string) {
    return `${this.VERSION}/games/${id}/update`;
  },
  API_CHANGE_STATUS_GAME() {
    return `${this.VERSION}/games/change-status`;
  },
  API_GET_GAME_DETAIL(id: string) {
    return `${this.VERSION}/games/${id}/detail`;
  },

  API_REORDER_GAME() {
    return `${this.VERSION}/games/reorder`;
  },
};

export const API_CATEGORY_GAMES_ROUTER = {
  VERSION: "v1",
  get API_GET_CATEGORY_GAMES() {
    return `${this.VERSION}/category-games`;
  },
  API_UPDATE_CATEGORY_GAME() {
    return `${this.VERSION}/category-games/update`;
  },
  API_DELETE_CATEGORY_GAME(id: string) {
    return `${this.VERSION}/category-games/${id}/delete`;
  },
  API_REORDER_CATEGORY_GAME() {
    return `${this.VERSION}/category-games/reorder`;
  },
};

export const API_CUSTOMER_ROUTER = {
  VERSION: "v1",
  get API_GET_CUSTOMER() {
    return `${this.VERSION}/customers`;
  },
  get API_GET_CUSTOMER_COUNT_TAB() {
    return `${this.VERSION}/customers/count`;
  },
  API_CREATE_CUSTOMER() {
    return `${this.VERSION}/customers/create`;
  },
  API_UPDATE_CUSTOMER(id: string) {
    return `${this.VERSION}/customers/${id}/update`;
  },
  API_GET_CUSTOMER_DETAIL(id: string) {
    return `${this.VERSION}/customers/${id}/detail`;
  },
  API_CHANGE_STATUS_CUSTOMER() {
    return `${this.VERSION}/customers/change-status`;
  },
  API_RESET_PASSWORD_CUSTOMER(id: string) {
    return `${this.VERSION}/customers/${id}/reset-password`;
  },

  API_IMPORT_CUSTOMER() {
    return `${this.VERSION}/customers/import`;
  },
};

export const API_COMPUTER_SESSION_ROUTER = {
  VERSION: "v1",
  get API_GET_COMPUTER_SESSION() {
    return `${this.VERSION}/computer-session`;
  },
};
export const API_RESERVATION_ROUTER = {
  VERSION: "v1",
  get API_GET_RESERVATION() {
    return `${this.VERSION}/reservations`;
  },
  get API_CREATE_RESERVATION() {
    return `${this.VERSION}/reservations/create`;
  },
  API_UPDATE_RESERVATION(id: string) {
    return `${this.VERSION}/reservations/${id}/update`;
  },
  API_DETAIL_RESERVATION(id: string) {
    return `${this.VERSION}/reservations/${id}/detail`;
  },
  API_CHANGE_STATUS_RESERVATION(id: string) {
    return `${this.VERSION}/reservations/${id}/change-status`;
  },
};

export const API_CATEGORIES_FOOD_ROUTER = {
  VERSION: "v1",
  get API_GET_CATEGORIES_FOOD() {
    return `${this.VERSION}/categories-food`;
  },
  API_CREATE_CATEGORIES_FOOD() {
    return `${this.VERSION}/categories-food/create`;
  },
  API_UPDATE_CATEGORIES_FOOD() {
    return `${this.VERSION}/categories-food/update`;
  },
  API_DELETE_CATEGORIES_FOOD(id: string) {
    return `${this.VERSION}/categories-food/${id}/delete`;
  },
  API_GET_CATEGORIES_FOOD_CHANGE_SHOW(id: string) {
    return `${this.VERSION}/categories-food/${id}/change-show`;
  },
  API_REORDER_CATEGORIES_FOOD() {
    return `${this.VERSION}/categories-food/reorder`;
  },
};

export const API_MATERIALS_ROUTER = {
  VERSION: "v1",
  get API_GET_MATERIALS() {
    return `${this.VERSION}/materials`;
  },
  API_CREATE_MATERIALS() {
    return `${this.VERSION}/materials/create`;
  },
  API_UPDATE_MATERIALS(id: string) {
    return `${this.VERSION}/materials/${id}/update`;
  },
  API_DELETE_MATERIALS(id: string) {
    return `${this.VERSION}/materials/${id}/delete`;
  },
};

export const API_NEWS_ROUTER = {
  VERSION: "v1",
  get API_GET_NEWS() {
    return `${this.VERSION}/news`;
  },
  get API_CREATE_NEWS() {
    return `${this.VERSION}/news/create`;
  },
  API_UPDATE_NEWS(id: string) {
    return `${this.VERSION}/news/${id}/update`;
  },
  API_DETAIL_NEWS(id: string) {
    return `${this.VERSION}/news/${id}/detail`;
  },
  get API_CHANGE_STATUS_NEWS() {
    return `${this.VERSION}/news/change-status`;
  },
};

export const API_WALLET_TRANSACTIONS_ROUTER = {
  VERSION: "v1",
  get API_GET_WALLET_TRANSACTIONS() {
    return `${this.VERSION}/wallet-transactions`;
  },
  get API_GET_WALLET_TRANSACTIONS_COUNT_TAB() {
    return `${this.VERSION}/wallet-transactions/count-tab`;
  },
  API_CREATE_WALLET_TRANSACTIONS() {
    return `${this.VERSION}/wallet-transactions/create`;
  },
  API_UPDATE_WALLET_TRANSACTIONS(id: string) {
    return `${this.VERSION}/wallet-transactions/${id}/update`;
  },
  API_CHANGE_STATUS_WALLET_TRANSACTIONS(id: string) {
    return `${this.VERSION}/wallet-transactions/${id}/change-status`;
  },
};

export const API_PRODUCT_ROUTER = {
  VERSION: "v1",
  get API_GET_PRODUCTS() {
    return `${this.VERSION}/products`;
  },
  get API_GET_PRODUCTS_BRANCH() {
    return `${this.VERSION}/products/branch`;
  },
  API_CREATE_PRODUCTS() {
    return `${this.VERSION}/products/create`;
  },
  API_DETAIL_PRODUCTS(id: string) {
    return `${this.VERSION}/products/${id}/detail`;
  },
  API_UPDATE_PRODUCTS(id: string) {
    return `${this.VERSION}/products/${id}/update`;
  },
  API_DELETE_PRODUCTS(id: string) {
    return `${this.VERSION}/products/${id}/delete`;
  },
  API_CHANGE_STATUS_BRAND_PRODUCTS() {
    return `${this.VERSION}/products/brand-change-status`;
  },
  API_CHANGE_STATUS_BRANCH_PRODUCTS() {
    return `${this.VERSION}/products/branch-change-status`;
  },
  API_REORDER_PRODUCTS() {
    return `${this.VERSION}/products/reorder`;
  },
};

export const API_ORDER_ROUTER = {
  VERSION: "v1",
  get API_GET_ORDERS() {
    return `${this.VERSION}/orders`;
  },
  API_CREATE_ORDER() {
    return `${this.VERSION}/orders/create`;
  },
  API_DETAIL_ORDER(id: string) {
    return `${this.VERSION}/orders/${id}/detail`;
  },
  API_UPDATE_ORDER(id: string) {
    return `${this.VERSION}/orders/${id}/update`;
  },
  API_DONE_ORDER(id: string) {
    return `${this.VERSION}/orders/${id}/done`;
  },
  API_CANCEL_ORDER(id: string) {
    return `${this.VERSION}/orders/${id}/cancel`;
  },
  API_CANCEL_CHEF_CONFIRM(id: string) {
    return `${this.VERSION}/orders/${id}/chef-confirm`;
  },
  API_CANCEL_CHEF_COMPLETE(id: string) {
    return `${this.VERSION}/orders/${id}/complete`;
  },

  API_REFUND_PAYMENT(id: string) {
    return `${this.VERSION}/orders/${id}/refund-payment`;
  },

  API_CONFIRM_PAYMENT(id: string) {
    return `${this.VERSION}/orders/${id}/confirm-payment`;
  },
  API_PAYMENT_CONFIRM() {
    return `${this.VERSION}/payments/confirm`;
  },
};

export const API_BRAND_ROUTER = {
  VERSION: "v1",
  get API_BRAND_SETTINGS() {
    return `${this.VERSION}/brands/settings`;
  },

  get API_GET_PROMOTIONS_SUB_MENU_CONFIG() {
    return `${this.VERSION}/brands/get-promotions`;
  },
};

export const API_RECEIPT_CATEGORIES_ROUTER = {
  VERSION: "v1",
  get API_GET_RECEIPT_CATEGORIES() {
    return `${this.VERSION}/receipt-payment-categories`;
  },
  API_CHANGE_STATUS_RECEIPT_CATEGORIES() {
    return `${this.VERSION}/receipt-payment-categories/change-status`;
  },
  API_COUNT_TAB_RECEIPT_CATEGORIES() {
    return `${this.VERSION}/receipt-payment-categories/count`;
  },
  API_CREATE_RECEIPT_CATEGORIES() {
    return `${this.VERSION}/receipt-payment-categories/create`;
  },
  API_UPDATE_RECEIPT_CATEGORIES(id: string) {
    return `${this.VERSION}/receipt-payment-categories/${id}/update`;
  },
};

export const API_RECEIPT_PAYMENT_ROUTER = {
  VERSION: "v1",
  get API_GET_RECEIPT_PAYMENTS() {
    return `${this.VERSION}/receipt-payments`;
  },

  API_CREATE_RECEIPT_PAYMENTS() {
    return `${this.VERSION}/receipt-payments/create`;
  },
  API_UPDATE_RECEIPT_PAYMENTS(id: string) {
    return `${this.VERSION}/receipt-payments/${id}/update`;
  },
  API_CHANGE_STATUS_RECEIPT_PAYMENTS() {
    return `${this.VERSION}/receipt-payments/change-status`;
  },
};

export const API_INVENTORY_ROUTER = {
  VERSION: "v1",
  get API_GET_INVENTORY() {
    return `${this.VERSION}/inventory`;
  },
  get API_GET_INVENTORY_IMPORT() {
    return `${this.VERSION}/inventory/import`;
  },
  API_IMPORT_INVENTORY() {
    return `${this.VERSION}/inventory/import/create`;
  },
  API_IMPORT_CONFIRM_INVENTORY(id: string) {
    return `${this.VERSION}/inventory/import/${id}/confirm`;
  },
  API_IMPORT_CANCEL_INVENTORY(id: string) {
    return `${this.VERSION}/inventory/import/${id}/cancel`;
  },
  API_IMPORT_UPDATE_INVENTORY(id: string) {
    return `${this.VERSION}/inventory/import/${id}/update`;
  },
  API_IMPORT_DETAIL_INVENTORY(id: string) {
    return `${this.VERSION}/inventory/import/${id}/detail`;
  },
  //check
  get API_INVENTORY_CHECK() {
    return `${this.VERSION}/inventory/check`;
  },
  API_INVENTORY_CHECK_DETAIL(id: string) {
    return `${this.VERSION}/inventory/check/${id}/detail`;
  },
  API_INVENTORY_CHECK_UPDATE(id: string) {
    return `${this.VERSION}/inventory/check/${id}/update`;
  },
  API_INVENTORY_CHECK_CREATE() {
    return `${this.VERSION}/inventory/check/create`;
  },
  API_INVENTORY_CHECK_CONFIRM(id: string) {
    return `${this.VERSION}/inventory/check/${id}/confirm`;
  },
  API_INVENTORY_CHECK_CANCEL(id: string) {
    return `${this.VERSION}/inventory/check/${id}/cancel`;
  },
};

export const API_EMPLOYEE_ACTIVITY_ROUTER = {
  VERSION: "v1",
  get API_GET_EMPLOYEE_ACTIVITY() {
    return `${this.VERSION}/employee-activity-logs`;
  },
};
export const API_SHIFT_SESSION_ROUTER = {
  VERSION: "v1",
  get API_GET_EXPECTED_AMOUNT() {
    return `${this.VERSION}/shift-session/expected-amount`;
  },
  get API_POST_OPEN_SHIFT() {
    return `${this.VERSION}/shift-session/open-shift`;
  },
  API_POST_CLOSE_SHIFT(id: string) {
    return `${this.VERSION}/shift-session/${id}/close-shift`;
  },
  get API_GET_CURRENT_SHIFT() {
    return `${this.VERSION}/shift-session/current-shift`;
  },
  API_GET_SHIFT_DETAIL(id: string) {
    return `${this.VERSION}/shift-session/${id}/detail`;
  },
  get API_GET_SHIFT_LIST() {
    return `${this.VERSION}/shift-session`;
  },

  get API_GET_REPORTS_SHIFT_SESSION() {
    return `${this.VERSION}/reports/shift-session`;
  },
};

export const API_SHIFT_ROUTER = {
  VERSION: "v1",

  get API_GET_SHIFTS() {
    return `${this.VERSION}/shifts`;
  },
  get API_GET_SHIFTS_EMPLOYEE() {
    return `${this.VERSION}/shifts/employee`;
  },
  API_CREATE_SHIFT() {
    return `${this.VERSION}/shifts/create`;
  },
  API_UPDATE_SHIFT(id: string) {
    return `${this.VERSION}/shifts/${id}/update`;
  },
  API_GET_SHIFT_DETAIL(id: string) {
    return `${this.VERSION}/shifts/${id}/detail`;
  },
  API_CHANGE_STATUS_SHIFT() {
    return `${this.VERSION}/shifts/change-status`;
  },
};

export const API_ATTENDANCES_ROUTER = {
  VERSION: "v1",

  API_POST_CHECK_IN() {
    return `${this.VERSION}/attendances/check-in`;
  },
  API_POST_CHECK_OUT() {
    return `${this.VERSION}/attendances/check-out`;
  },
  get API_GET_ATTENDANCES() {
    return `${this.VERSION}/attendances`;
  },
  get API_GET_ATTENDANCE_MONTHLY() {
    return `${this.VERSION}/attendances/monthly`;
  },
  API_UPDATE_ATTENDANCE(id: string) {
    return `${this.VERSION}/attendances/${id}/update`;
  },
  API_GET_ATTENDANCE_DETAIL(id: string) {
    return `${this.VERSION}/attendances/${id}/detail`;
  },
  API_GET_ATTENDANCE_CURRENT(id: string) {
    return `${this.VERSION}/attendances/${id}/current`;
  },
};

export const API_PROMOTION_COMBO_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_COMBO() {
    return `${this.VERSION}/promotion-campaigns/combo`;
  },
  get API_GET_PROMOTIONS_COMBO_RUNNING() {
    return `${this.VERSION}/promotion-campaigns/running/combo`;
  },
  get API_GET_PROMOTIONS_COMBO_COUNT_TAB() {
    return `${this.VERSION}/promotion-campaigns/combo/count-tab`;
  },
  API_GET_PROMOTIONS_COMBO_DETAIL(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/detail`;
  },
  API_CREATE_PROMOTION_COMBO_INFO() {
    return `${this.VERSION}/promotion-campaigns/combo/create`;
  },
  API_UPDATE_PROMOTION_COMBO_INFO(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/update`;
  },
  API_CREATE_PROMOTION_COMBO() {
    return `${this.VERSION}/promotion-campaigns/combo/create`;
  },
  API_UPDATE_PROMOTION_COMBO(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/update`;
  },
  API_CHANGE_STATUS_PROMOTION_COMBO(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/change-status`;
  },
  API_CHANGE_STATUS_PROMOTION_COMBO_BUY(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/buy/${id}/change-status`;
  },
  API_START_PROMOTION_COMBO(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/start`;
  },
  API_CANCEL_PROMOTION_COMBO(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/cancel`;
  },
  API_BUY_STATUS_PROMOTION_COMBO(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/buy`;
  },

  API_REFUND_PAYMENT(id: string) {
    return `${this.VERSION}/promotion-campaigns/combo/${id}/refund-payment`;
  },
};

export const API_PROMOTION_RECHARGE_PACKAGE_MILESTONES_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_RECHARGE_PACKAGE_MILESTONES() {
    return `${this.VERSION}/recharge-package-milestones`;
  },

  API_CREATE_PROMOTION_RECHARGE_PACKAGE_MILESTONES() {
    return `${this.VERSION}/recharge-package-milestones/create`;
  },
  API_UPDATE_PROMOTION_RECHARGE_PACKAGE_MILESTONES(id: string) {
    return `${this.VERSION}/recharge-package-milestones/${id}/update`;
  },
  API_DELETE_PROMOTION_RECHARGE_PACKAGE_MILESTONES(id: string) {
    return `${this.VERSION}/recharge-package-milestones/${id}/delete`;
  },
};

export const API_PROMOTION_BUY_HISTORY_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_BUY_HISTORY() {
    return `${this.VERSION}/customer-promotion-campaign-histories/buy-history`;
  },
  get API_GET_PROMOTIONS_BUY_HISTORY_UNPAID() {
    return `${this.VERSION}/customer-promotion-campaign-histories/unpaid-buy-history`;
  },

  API_CANCEL_COMBO_PROMOTION_BUY_HISTORY(id: string) {
    return `${this.VERSION}/customer-promotion-campaign-histories/combo/${id}/cancel`;
  },

  API_CANCEL_PACKAGE_TICKET_PROMOTION_BUY_HISTORY(id: string) {
    return `${this.VERSION}/customer-promotion-campaign-histories/ticket/${id}/cancel`;
  },

  API_REFUND_PAYMENT(id: string) {
    return `${this.VERSION}/customer-promotion-campaign-histories/${id}/refund-payment`;
  },

  get API_GET_COMPUTER_SESSION() {
    return `${this.VERSION}/computer-session`;
  },
};

export const API_PROMOTION_MEMBERSHIP_LEVELS_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_MEMBERSHIP_LEVELS() {
    return `${this.VERSION}/membership-levels`;
  },
  API_CREATE_PROMOTION_MEMBERSHIP_LEVELS() {
    return `${this.VERSION}/membership-levels/create`;
  },
  API_UPDATE_PROMOTION_MEMBERSHIP_LEVELS(id: string) {
    return `${this.VERSION}/membership-levels/${id}/update`;
  },
  API_DELETE_PROMOTION_MEMBERSHIP_LEVELS(id: string) {
    return `${this.VERSION}/membership-levels/${id}/delete`;
  },
};

export const API_PROMOTION_TICKET_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_TICKET() {
    return `${this.VERSION}/promotion-campaigns/ticket`;
  },
  get API_GET_PROMOTIONS_TICKET_RUNNING() {
    return `${this.VERSION}/promotion-campaigns/running/ticket`;
  },
  get API_GET_PROMOTIONS_TICKET_COUNT_TAB() {
    return `${this.VERSION}/promotion-campaigns/ticket/count-tab`;
  },
  API_GET_PROMOTIONS_TICKET_DETAIL(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/${id}/detail`;
  },
  API_CREATE_PROMOTION_TICKET_INFO() {
    return `${this.VERSION}/promotion-campaigns/ticket/create`;
  },
  API_UPDATE_PROMOTION_TICKET_INFO(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/${id}/update`;
  },
  API_CREATE_PROMOTION_TICKET() {
    return `${this.VERSION}/promotion-campaigns/ticket/create`;
  },
  API_UPDATE_PROMOTION_TICKET(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/${id}/update`;
  },
  API_CHANGE_STATUS_PROMOTION_TICKET(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/${id}/change-status`;
  },
  API_CHANGE_STATUS_PROMOTION_TICKET_BUY(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/buy/${id}/change-status`;
  },
  API_START_PROMOTION_TICKET(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/start`;
  },
  API_CANCEL_PROMOTION_TICKET(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/cancel`;
  },
  API_BUY_STATUS_PROMOTION_TICKET(id: string) {
    return `${this.VERSION}/promotion-campaigns/ticket/${id}/buy`;
  },
};

export const API_PROMOTION_CUSTOMER_DISCOUNT_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_CUSTOMER_DISCOUNT() {
    return `${this.VERSION}/promotion-campaigns/customer-discount`;
  },
  get API_GET_PROMOTIONS_CUSTOMER_DISCOUNT_RUNNING() {
    return `${this.VERSION}/promotion-campaigns/running/customer-discount`;
  },
  get API_GET_PROMOTIONS_CUSTOMER_DISCOUNT_COUNT_TAB() {
    return `${this.VERSION}/promotion-campaigns/customer-discount/count-tab`;
  },
  API_GET_PROMOTIONS_CUSTOMER_DISCOUNT_DETAIL(id: string) {
    return `${this.VERSION}/promotion-campaigns/customer-discount/${id}/detail`;
  },
  API_CREATE_PROMOTION_CUSTOMER_DISCOUNT_INFO() {
    return `${this.VERSION}/promotion-campaigns/customer-discount/create`;
  },
  API_UPDATE_PROMOTION_CUSTOMER_DISCOUNT_INFO(id: string) {
    return `${this.VERSION}/promotion-campaigns/customer-discount/${id}/update`;
  },
  API_CREATE_PROMOTION_CUSTOMER_DISCOUNT() {
    return `${this.VERSION}/promotion-campaigns/customer-discount/create`;
  },
  API_UPDATE_PROMOTION_CUSTOMER_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/customer-discount/${id}/update`;
  },
  API_CHANGE_STATUS_PROMOTION_CUSTOMER_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/customer-discount/${id}/change-status`;
  },
  API_START_PROMOTION_CUSTOMER_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/start`;
  },
  API_CANCEL_PROMOTION_CUSTOMER_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/cancel`;
  },
  API_BUY_STATUS_PROMOTION_CUSTOMER_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/customer-discount/${id}/buy`;
  },
};

export const API_PROMOTION_AREA_DISCOUNT_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTIONS_AREA_DISCOUNT() {
    return `${this.VERSION}/promotion-campaigns/area-discount`;
  },
  get API_GET_PROMOTIONS_AREA_DISCOUNT_RUNNING() {
    return `${this.VERSION}/promotion-campaigns/running/area-discount`;
  },
  get API_GET_PROMOTIONS_AREA_DISCOUNT_COUNT_TAB() {
    return `${this.VERSION}/promotion-campaigns/area-discount/count-tab`;
  },
  API_GET_PROMOTIONS_AREA_DISCOUNT_DETAIL(id: string) {
    return `${this.VERSION}/promotion-campaigns/area-discount/${id}/detail`;
  },
  API_CREATE_PROMOTION_AREA_DISCOUNT_INFO() {
    return `${this.VERSION}/promotion-campaigns/area-discount/create`;
  },
  API_UPDATE_PROMOTION_AREA_DISCOUNT_INFO(id: string) {
    return `${this.VERSION}/promotion-campaigns/area-discount/${id}/update`;
  },
  API_CREATE_PROMOTION_AREA_DISCOUNT() {
    return `${this.VERSION}/promotion-campaigns/area-discount/create`;
  },
  API_UPDATE_PROMOTION_AREA_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/area-discount/${id}/update`;
  },
  API_CHANGE_STATUS_PROMOTION_AREA_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/area-discount/${id}/change-status`;
  },
  API_START_PROMOTION_AREA_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/start`;
  },
  API_CANCEL_PROMOTION_AREA_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/${id}/cancel`;
  },
  API_BUY_STATUS_PROMOTION_AREA_DISCOUNT(id: string) {
    return `${this.VERSION}/promotion-campaigns/area-discount/${id}/buy`;
  },

  get API_TIMELINE_PROMOTION_AREA_DISCOUNT() {
    return `${this.VERSION}/promotion-campaigns/area-discount/timeline`;
  },
};

export const API_BANNER_ROUTER = {
  VERSION: "v1",
  get API_GET_BANNERS() {
    return `${this.VERSION}/banners`;
  },
  get API_GET_BANNERS_COUNT_TAB() {
    return `${this.VERSION}/banners/count`;
  },
  API_CREATE_BANNER() {
    return `${this.VERSION}/banners/create`;
  },
  API_UPDATE_BANNER(id: string) {
    return `${this.VERSION}/banners/${id}/update`;
  },
  API_CHANGE_STATUS_BANNER(id: string) {
    return `${this.VERSION}/banners/${id}/change-status`;
  },
  API_GET_BANNER_DETAIL(id: string) {
    return `${this.VERSION}/banners/${id}/detail`;
  },
};

export const API_EMPLOYEE_NOTIFICATION_HISTORY_ROUTER = {
  VERSION: "v1",
  get API_GET_EMPLOYEE_NOTIFICATION_HISTORY() {
    return `${this.VERSION}/employee-notification-history`;
  },
  get API_GET_UNREAD_COUNT_EMPLOYEE_NOTIFICATION_HISTORY() {
    return `${this.VERSION}/employee-notification-history/unread-count`;
  },

  API_READ_EMPLOYEE_NOTIFICATION_HISTORY(id: string) {
    return `${this.VERSION}/employee-notification-history/${id}/read`;
  },

  API_READ_ALL_EMPLOYEE_NOTIFICATION_HISTORY() {
    return `${this.VERSION}/employee-notification-history/read-all`;
  },
};

export const API_PRINTERS_ROUTER = {
  VERSION: "v1",
  get API_GET_PRINTERS() {
    return `${this.VERSION}/printers`;
  },
  get API_GET_PRINTERS_COUNT_TAB() {
    return `${this.VERSION}/printers/count-tab`;
  },
  API_UPDATE_PRINTERS(id: string) {
    return `${this.VERSION}/printers/${id}/update`;
  },
  API_CHANGE_STATUS_PRINTERS(id: string) {
    return `${this.VERSION}/printers/${id}/change-status`;
  },
  API_CREATE_PRINTERS() {
    return `${this.VERSION}/printers/create`;
  },
};
export const API_REPORTS_ROUTER = {
  VERSION: "v1",
  get API_GET_REPORTS() {
    return `${this.VERSION}/reports`;
  },
  get API_GET_CHECK_STATUS_COMPUTER_REPORTS() {
    return `${this.VERSION}/reports/check-status-computer`;
  },
  get API_GET_TOTAL_NEW_CUSTOMER_REPORTS() {
    return `${this.VERSION}/reports/total-new-customer`;
  },
  get API_GET_SERVICE_ORDER_REPORTS() {
    return `${this.VERSION}/reports/service-order`;
  },
  get API_GET_SERVICE_PROMOTION_REPORTS() {
    return `${this.VERSION}/reports/service-promotion`;
  },
};

export const API_BACKGROUND_ROUTER = {
  VERSION: "v1",

  get API_GET_BACKGROUND() {
    return `${this.VERSION}/brands/get-background`;
  },

  API_UPDATE_BACKGROUND() {
    return `${this.VERSION}/brands/update-background`;
  },
};
export const API_CHAT_ROUTER = {
  VERSION: "v1",

  API_GET_MESSAGE(id: string) {
    return `${this.VERSION}/computer-session-messages/${id}/detail`;
  },
};

export const API_DEVICE_TOKENS_ROUTER = {
  VERSION: "v1",

  API_REGISTER_DEVICE_TOKENS() {
    return `${this.VERSION}/device-tokens/register`;
  },

  API_REMOVE_DEVICE_TOKENS() {
    return `${this.VERSION}/device-tokens/remove`;
  },
};

export const API_CONFIGS_ROUTER = {
  API_CONFIGS_PUBLIC() {
    return `public/configs`;
  },
};

// Đây là API của service ADMIN nếu có sửa version của service manager thì đừng sửa cái này
export const API_SYSTEM_SETTINGS_ROUTER = {
  VERSION: "v1",

  API_PUBLIC_KEY() {
    return `${this.VERSION}/system-settings/public-key`;
  },

  API_SYSTEM_SETTINGS() {
    return `${this.VERSION}/system-settings`;
  },
};

export const API_API_KEY_ROUTER = {
  VERSION: "v1",

  get API_GET_API_KEYS() {
    return `${this.VERSION}/external-api-keys`;
  },

  get API_GET_ALLOW_APIS() {
    return `${this.VERSION}/external-api-keys/allow-apis`;
  },

  API_CREATE_API_KEY() {
    return `${this.VERSION}/external-api-keys/create`;
  },

  API_UPDATE_API_KEY(id: string) {
    return `${this.VERSION}/external-api-keys/${id}/update`;
  },

  API_REMOVE_API_KEY(id: string) {
    return `${this.VERSION}/external-api-keys/${id}/remove`;
  },
};

export const API_WALLET_HISTORIES_ROUTER = {
  VERSION: "v1",

  get API_GET_WALLET_HISTORIES() {
    return `${this.VERSION}/wallet-histories`;
  },
};

export const API_PROMOTION_CREDIT_ROUTER = {
  VERSION: "v1",

  get API_GET_PROMOTION_CREDITS() {
    return `${this.VERSION}/promotion-credits`;
  },
  API_CREATE_PROMOTION_CREDIT() {
    return `${this.VERSION}/promotion-credits/create`;
  },
  API_GET_PROMOTION_CREDIT_DETAIL(id: string) {
    return `${this.VERSION}/promotion-credits/${id}/detail`;
  },
};

export const API_PLAY_TIME_PACKAGES_ROUTER = {
  VERSION: "v1",

  get API_GET_PLAY_TIME_PACKAGES() {
    return `${this.VERSION}/play-time-packages`;
  },
  get API_GET_PLAY_TIME_PACKAGES_COUNT_TAB() {
    return `${this.VERSION}/play-time-packages/count`;
  },
  API_CREATE_PLAY_TIME_PACKAGE() {
    return `${this.VERSION}/play-time-packages/create`;
  },
  API_UPDATE_PLAY_TIME_PACKAGE(id: string) {
    return `${this.VERSION}/play-time-packages/${id}/update`;
  },
  API_CHANGE_STATUS_PLAY_TIME_PACKAGE() {
    return `${this.VERSION}/play-time-packages/change-status`;
  },
  API_SELL_PLAY_TIME_PACKAGE() {
    return `${this.VERSION}/play-time-packages/sell`;
  },
  get API_GET_PLAY_TIME_TRANSACTIONS() {
    return `${this.VERSION}/play-time-packages/transactions`;
  },
  API_CONFIRM_CASH_PLAY_TIME_TRANSACTION(id: string) {
    return `${this.VERSION}/play-time-packages/transactions/${id}/confirm-cash`;
  },
  API_CANCEL_PLAY_TIME_TRANSACTION(id: string) {
    return `${this.VERSION}/play-time-packages/transactions/${id}/cancel`;
  },
};

export const API_DEDUCTION_PRIORITY_ROUTER = {
  VERSION: "v1",

  get API_GET_DEDUCTION_PRIORITY() {
    return `${this.VERSION}/brands/deduction-priority`;
  },
  API_UPDATE_DEDUCTION_PRIORITY() {
    return `${this.VERSION}/brands/deduction-priority`;
  },
};
